module.exports = __webpack_public_path__ + "resources/img/img_dsm1_m_en.8a2501b15f4a014b25143201da6c7bc8.png";